import { Fragment, ReactElement } from 'react';
import ResearchMarriageNonResidentDetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageNonResidentDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNonResidentDetailNotificationsCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchMarriageNonResidentDetailNotificationsCivilStatusPage.displayName =
  'Research Marriage Detail Notifications CivilStatusPage component';

export default ResearchMarriageNonResidentDetailNotificationsCivilStatusPage;
